export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_3.a811c15c.mp3";